import * as React from "react";
import PageHeaderView from "../../body/PageHeaderView";
import PageContentView from "../../body/PageContentView";
import {none, Option, some} from "ts-option";
import Loading from "../../ui/loading/Loading";
import {OnFailure, OnSuccess} from "../../../store/action/actionHelpers";
import ButtonGroupWrapper from "../../../hiberUiKit/src/atoms/Buttons/ButtonGroupWrapper";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import FinanceProductTable from "./FinanceProductTable";
import FinanceProduct from "../../../model/financeProduct/FinanceProduct";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import Toast from "../../helper/Toast";
import {Dispatch} from "redux";
import {updateFinanceProductsSortOrder} from "../../../store/action/financeProduct/financeProduct";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import CreateFinanceProductModal from "../../financeProduct/modal/CreateFinanceProductModal";
import EditFinanceProductModal from "../../financeProduct/modal/EditFinanceProductModal";
import deepEqual = require("deep-equal");

interface DispatchProps {
	/**
	 * Sort order update method
	 * @param {FinanceProduct[]} items
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	updateSortOrder: (items: FinanceProduct[], onSuccess: OnSuccess, onFailure: OnFailure) => void;
}

interface ReduxProps {
	/**
	 * Items
	 */
	items: Option<FinanceProduct[]>
}

interface IComponentState {
	/**
	 * Finance Products with new sort order.
	 */
	items: FinanceProduct[];
	/**
	 * Indicates if sort order has changed.
	 */
	isDirty: boolean;
	/**
	 * Finance product create modal visibility flag
	 */
	isCreateModalVisible: boolean
	/**
	 * Finance product to edit
	 */
	item: Option<FinanceProduct>;
}

type Props = ReduxProps & DispatchProps;

/**
 * Finance Product list component.
 */
class FinanceProductList extends React.Component<Props, IComponentState> {

	constructor(props: Props) {
		super(props);
		this.state = {
			items: props.items.getOrElse([]),
			isDirty: false,
			isCreateModalVisible: false,
			item: none
		};
		this.onSubmitOrder = this.onSubmitOrder.bind(this);
		this.onOrderChange = this.onOrderChange.bind(this);
	}

	componentWillReceiveProps(nextProps: Props) {
		if (!deepEqual(this.props.items.getOrElse([]), nextProps.items.getOrElse([]))) {
			this.setState({items: nextProps.items.getOrElse([])})
		}
	}

	render() {
		const isSaveButtonDisabled = this.props.items.map(items => items.length == 0).getOrElse(true) || !this.state.isDirty;
		return (
			<div>
				<PageHeaderView header={"Finance Products"}>
					<ButtonGroupWrapper>
						<ButtonPrimary onClick={() => this.setState({isCreateModalVisible: true})}
									   label={`Create finance product`}
									   variant={"burgundy"}/>
						<ButtonPrimary onClick={() => this.onSubmitOrder(this.state.items)}
									   disabled={isSaveButtonDisabled}
									   label={"Save Changes"}
									   variant={"burgundy"}/>
					</ButtonGroupWrapper>
				</PageHeaderView>
				<PageContentView>
					<Loading isLoading={this.props.items.isEmpty}>
						<FinanceProductTable items={this.state.items}
											 onRowClick={(item) => this.setState({item: some(item)})}
											 onOrderChange={this.onOrderChange}/>
					</Loading>
				</PageContentView>
				{this.state.isCreateModalVisible &&
				<CreateFinanceProductModal closeModal={() => this.setState({isCreateModalVisible: false})}/>}
				{this.state.item.map(fp => <EditFinanceProductModal closeModal={() => this.setState({item: none})}
																	editedFinanceProduct={fp}/>
				).orNull}
			</div>
		)
	}

	/**
	 * Submit order change.
	 * @param {FinanceProduct[]} items
	 */
	onSubmitOrder(items: FinanceProduct[]) {
		this.props.updateSortOrder(
			items,
			() => {
				this.setState({isDirty: false},
					() => {
						Toast.info("Sort order has been updated.", "Update sort order");
					});
			},
			(e) => {
				notifyBugsnagAndShowToast(e, "Update sort order");
			}
		);
	}

	/**
	 * Sort order change callback.
	 * @param {FinanceProduct[]} items
	 */
	onOrderChange(items: FinanceProduct[]) {
		this.setState({items: items, isDirty: true});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		updateSortOrder: (items: FinanceProduct[], onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			updateFinanceProductsSortOrder(items, onSuccess, onFailure))
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.financeProduct.financeProducts
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(FinanceProductList)
